export default {
  factory: {
    city: { en: "Ivano-Frankivsk", uk: "Івано-Франківськ" },
    street: { en: "I.Makuha str., 6", uk: "вул. І.Макуха, 6" },
    postalCode: "76014",
    phones: ["+380503770801", "+380673270801", "+380342522127"],
    position: [48.9064118, 24.7253379],
    email: "kuvert.ua@kuvert.if.ua",
  },
  offices: [
    {
      city: { en: "Kyiv", uk: "Київ" },
      street: {
        en: "Delivery of goods by prior arrangement.",
        uk: "Доставка товару за попередньою домовленістю.",
      },
      // postalCode: "03134",
      phones: ["+380670090801", "+380504334581", "+380503737565"],
      position: [50.4214245, 30.3981391],
      email: "kuvert.kyiv@gmail.com",
    },
    {
      city: { en: "Dnipro", uk: "Дніпро" },
      street: {
        en: "B. Khmelnytskogo str., 11A",
        uk: "вул. Б.Хмельницького, 11А",
      },
      postalCode: "49000",
      phones: ["+380503737573", "+380504332838"],
      position: [48.5070453, 35.0794858],
      email: "kuvert.dn@gmail.com",
    },
    {
      city: { en: "Kharkiv", uk: "Харків" },
      street: {
        en: "Delivery of goods by prior arrangement.",
        uk: "Доставка товару за попередньою домовленістю.",
      },
      // postalCode: "61037",
      phones: ["+380504332566"],
      position: [49.977438, 36.280344],
      email: "kuvert.kharkiv@gmail.com",
    },
    {
      city: { en: "Lviv", uk: "Львів" },
      street: { en: "Zelena str., 251", uk: "вул. Зелена, 251" },
      postalCode: "79035",
      phones: ["+380503170387"],
      position: [49.806572, 24.064176],
      email: "konwert@ukr.net",
    },
  ],
}
